<template>
  <div id="asideNav_msg">
    <div class="asideNav_button">
      <el-button round class="button_msg"  circle icon="el-icon-bell" @click="isShowMessage= !isShowMessage " >
      </el-button>
      <span v-show="isShowDot" class="dot_msg"></span>
    </div>
    <transition>
        <div v-show="isShowMessage" class="asideNav_main">
          <slot></slot>
        </div>
    </transition>
  </div>
</template>
<style scoped lang="stylus" rel="stylesheet/stylus">
.dot_msg {
  width: 10px;
  height: 10px;
  background: #f00;
  border-radius: 5px;
  position: relative;
  display: block;
  left: 33px;
  top: 9px;
}
.asideNav_button
  background #00adaa;
  float: left;
  border-radius:5px 0 0 5px;
.button_msg{
  font-size: 25px;
  background #00adaa !important;
  color #fff !important;
  float: left;
}
.button_msg:hover,.button_msg:active{
  font-size: 27px;
}
#asideNav_msg
  position :fixed;
  right: 5px;
  bottom :  5px;
  z-index 999;

.asideNav_main
  float: right;
</style>

<script>
export default {
  props:{
    isShowDot:{//是否出现红点
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      isShowMessage:false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// asideNav.vue?9058d86c